import BaseModulePlugins from '@/store/baseModule/plugins';
import { getAlertsInfos } from '@/services/services/alertsService';
import getRecurrenceInfos from '@/services/services/recurrence.service';
import { selfAssign } from '@/services/api/internal/requestActions/selfAssign.api';
import getInterventionsInfos from '@/services/services/interventions.service';
import registerTreated, {
  TREATED_REQUESTS_MODULE_PATH,
} from '@/store/modules/requests/treated';
import registerTabModule from '@/store/TabModule';
import requestsModule from '@/store/modules/requests/module';
import { AUTHORIZATION_MODULE_PATH } from '@/store/modules/authorization';
import registerDispatcher from './dispatched';
import registerPaused from './paused';
import registerHistory from './history';
import registerRejectionTypes from './rejection_types';
import registerStates from './states';
import registerTreatments from './treatments';
import registerServices from './services';
import registerReasonsToBeContinued from './reasonsToBeContinued';
import registerLogs from './logs';
import registerRefresh from './refresh';
import registerPauseReason from './pause_reason';
import registerLater from './delayed';

export default (store) => {
  requestsModule(store);

  const basePlugin = new BaseModulePlugins({
    module: 'requests',
    store,
  });

  basePlugin.initAttributeFiltersWhenAttributesObjRefIsLoaded({});

  function setHISHabilitations() {
    const authHIS = [];
    if (store.getters[`${AUTHORIZATION_MODULE_PATH}/isPEM`]) {
      authHIS.push(true);
    }
    if (store.getters[`${AUTHORIZATION_MODULE_PATH}/isDispatcher`]) {
      authHIS.push(false);
    }
    store.commit('requests/SET_ATTRIBUTES_OBJ', {
      ...store.getters['requests/attributesObj'],
      his_treatment: {
        ...store.getters['requests/attributesObj'].his_treatment,
        values: authHIS,
      },
    });
    store.commit('requests/SET_ATTRIBUTES_OBJ_DEFAULT_FILTERS', {
      ...store.getters['requests/attributesObjDefaultFilters'],
      his_treatment: {
        ...store.getters['requests/attributesObjDefaultFilters'].his_treatment,
        values: authHIS,
      },
    });
  }
  if (store.getters[`${AUTHORIZATION_MODULE_PATH}/isInit`]) {
    setHISHabilitations();
  } else {
    store.subscribe((mutation) => {
      if (mutation.type === `boilerplate/SET_INIT`) {
        setHISHabilitations();
      }
    });
  }

  basePlugin.persistVuexMutationsToLocalStorage([
    'SET_ATTRIBUTES_OBJ',
    'SET_VIEW_TABLE',
  ]);
  basePlugin.loadItemsOnCurrentEntityChange();
  if (store.getters['boilerplate/isInit']) {
    store.dispatch('requests/initItems');
  }

  store.subscribe((mutation) => {
    if (
      mutation.type === 'requests/refresh/CREATE_SUCCESS' &&
      mutation.payload.refresh &&
      !store.getters['requests/isEditMode']
    ) {
      store.dispatch(`requests/refreshItems`);
    }
  });

  store.subscribe((mutation) => {
    if (
      mutation.type === 'requests/ADD_CURRENT_SUCCESS' &&
      !!store.getters['requests/assignActive']
    ) {
      store.commit('requests/SET_DISPATCHED', 'O');
      selfAssign(mutation.payload.id, {
        group_id: store.getters['global/groupId'],
      })
        .then(() => {
          store.commit('requests/REMOVE_ITEM', mutation.payload.id);
          store.dispatch('requests/dispatched/refreshItems');
        })
        .catch(() => {
          store.commit('requests/SET_DISPATCHED', 'N');
        })
        .finally(() => {
          store.commit('requests/SET_ASSIGN', false);
        });
    }
  });

  basePlugin.onItemsLoaded((items) => {
    getAlertsInfos(items)
      .then(async (resultList) => {
        store.commit('requests/SET_ALERTS', resultList);
      })
      .catch((err) => {
        store.dispatch('snackbar/setError', err);
      });
    getRecurrenceInfos(items)
      .then(async (resultList) => {
        store.commit('requests/SET_RECURRENCE', resultList);
      })
      .catch((err) => {
        store.dispatch('snackbar/setError', err);
      });
    getInterventionsInfos(items)
      .then(async (resultList) => {
        store.commit('requests/SET_INTERVENTIONS_IN_PROGRESS', resultList);
      })
      .catch((err) => {
        store.dispatch('snackbar/setError', err);
      });
  });
  registerLater(store, () => {
    registerHistory(store);
    registerDispatcher(store);
    registerPaused(store);
    registerRejectionTypes(store);
    registerStates(store);
    registerTreatments(store);
    registerServices(store);
    registerReasonsToBeContinued(store);
    registerLogs(store);
    registerRefresh(store);
    registerTreated(store);
    registerPauseReason(store);
  });

  registerTabModule({
    namespace: ['requests', 'table'],
    tabs: ['requests', TREATED_REQUESTS_MODULE_PATH],
    store,
    customGetters: {
      isTreatedRequestsShowed: (state) =>
        state.currentNamespace === TREATED_REQUESTS_MODULE_PATH,
      tabShowed: (state) => state.currentNamespace,
      isHIS: () => false,
    },
  });
};
